export var currencyFormatter = function currencyFormatter(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};